import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vShow as _vShow, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "d-sm-flex align-items-center" }
const _hoisted_4 = { class: "mt-10 mt-lg-0" }
const _hoisted_5 = { class: "row g-3 p-15 p-sm-20 p-md-25" }
const _hoisted_6 = { class: "col-md-3 position-relative" }
const _hoisted_7 = {
  class: "flex-grow-1 d-flex align-items-center px-3 text-secondary",
  style: {"font-size":"0.9rem"}
}
const _hoisted_8 = { class: "d-flex" }
const _hoisted_9 = {
  class: "border-end",
  style: {"width":"180px","background":"#fff"}
}
const _hoisted_10 = { class: "list-group list-group-flush" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  class: "calendar-section bg-white",
  style: {"min-width":"600px","min-height":"300px","display":"block !important"}
}
const _hoisted_13 = {
  key: 0,
  class: "border-top p-2 d-flex justify-content-between align-items-center bg-light",
  style: {"min-width":"100%"}
}
const _hoisted_14 = { class: "text-muted small ps-2" }
const _hoisted_15 = { class: "col-md-3" }
const _hoisted_16 = { class: "col-md-3" }
const _hoisted_17 = { class: "col-md-3" }
const _hoisted_18 = { class: "col-12 text-md-end" }
const _hoisted_19 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_20 = { class: "d-flex align-items-center mb-20" }
const _hoisted_21 = { class: "table-scroll-outer" }
const _hoisted_22 = { class: "table-scroll-mobile" }
const _hoisted_23 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_24 = { class: "shadow-none lh-1 fw-medium text-black-emphasis title ps-0" }
const _hoisted_25 = { class: "d-flex align-items-center" }
const _hoisted_26 = {
  key: 0,
  class: "text-warning"
}
const _hoisted_27 = {
  key: 1,
  class: "text-info"
}
const _hoisted_28 = { key: 2 }
const _hoisted_29 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_30 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_31 = { class: "text-nowrap" }
const _hoisted_32 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_33 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_34 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_35 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_36 = { style: {"word-wrap":"break-word","width":"50%"} }
const _hoisted_37 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }
const _hoisted_38 = { class: "dropdown" }
const _hoisted_39 = { class: "dropdown-menu" }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = ["onClick"]
const _hoisted_42 = ["onClick"]
const _hoisted_43 = ["href"]
const _hoisted_44 = ["onClick"]
const _hoisted_45 = { key: 0 }
const _hoisted_46 = ["onClick"]
const _hoisted_47 = { key: 1 }
const _hoisted_48 = ["onClick"]
const _hoisted_49 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_50 = { class: "s2" }
const _hoisted_51 = {
  key: 0,
  class: "circle"
}
const _hoisted_52 = ["onClick"]
const _hoisted_53 = {
  key: 1,
  class: "circle"
}
const _hoisted_54 = ["onClick"]
const _hoisted_55 = {
  key: 2,
  class: "circle"
}
const _hoisted_56 = ["onClick"]
const _hoisted_57 = {
  key: 3,
  class: "circle"
}
const _hoisted_58 = ["onClick"]
const _hoisted_59 = { class: "pagination-area d-md-flex mt-15 mt-md-25 mb-0 justify-content-between align-items-center" }
const _hoisted_60 = { class: "d-flex align-items-center mb-3 mb-md-0" }
const _hoisted_61 = { class: "mb-0 text-paragraph" }
const _hoisted_62 = { class: "fw-bold" }
const _hoisted_63 = { class: "fw-bold" }
const _hoisted_64 = { class: "fw-bold" }
const _hoisted_65 = { class: "mt-15 mt-md-0" }
const _hoisted_66 = { class: "pagination mb-0" }
const _hoisted_67 = {
  key: 0,
  class: "page-item"
}
const _hoisted_68 = {
  key: 1,
  class: "page-item disabled"
}
const _hoisted_69 = ["onClick"]
const _hoisted_70 = {
  key: 2,
  class: "page-item disabled"
}
const _hoisted_71 = {
  key: 3,
  class: "page-item"
}
const _hoisted_72 = {
  class: "modal fade",
  id: "filterLeadModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_73 = { class: "modal-dialog modal-dialog-centered modal-lg" }
const _hoisted_74 = { class: "modal-content p-15 p-md-40" }
const _hoisted_75 = { class: "modal-body" }
const _hoisted_76 = { class: "row" }
const _hoisted_77 = { class: "col-md-4" }
const _hoisted_78 = { class: "form-group mb-3" }
const _hoisted_79 = { class: "col-md-4" }
const _hoisted_80 = { class: "form-group mb-3" }
const _hoisted_81 = { class: "col-md-4" }
const _hoisted_82 = { class: "form-group mb-3" }
const _hoisted_83 = { class: "col-md-4" }
const _hoisted_84 = { class: "form-group mb-3" }
const _hoisted_85 = { class: "col-md-4" }
const _hoisted_86 = { class: "form-group mb-3" }
const _hoisted_87 = { class: "col-md-4" }
const _hoisted_88 = { class: "form-group mb-3" }
const _hoisted_89 = { class: "col-md-4" }
const _hoisted_90 = { class: "form-group mb-3" }
const _hoisted_91 = { class: "col-md-4" }
const _hoisted_92 = { class: "form-group mb-3" }
const _hoisted_93 = { class: "modal-footer" }
const _hoisted_94 = {
  class: "modal fade",
  id: "modalExortToday",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_95 = { class: "modal-dialog modal-xl" }
const _hoisted_96 = { class: "modal-content" }
const _hoisted_97 = { class: "modal-body" }
const _hoisted_98 = {
  class: "modal fade",
  id: "modal_detail_suivi",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_99 = { class: "modal-dialog modal-dialog-centered modal-xl" }
const _hoisted_100 = { class: "modal-content p-15 p-md-40" }
const _hoisted_101 = { class: "modal-body" }
const _hoisted_102 = {
  class: "modal fade",
  id: "modal_detail_colis",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_103 = { class: "modal-dialog modal-dialog-centered modal-xl" }
const _hoisted_104 = { class: "modal-content p-15 p-md-40" }
const _hoisted_105 = { class: "modal-body" }
const _hoisted_106 = {
  class: "modal fade",
  id: "modal_update",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_107 = { class: "modal-dialog modal-dialog-centered modal-xl" }
const _hoisted_108 = { class: "modal-content p-15 p-md-40" }
const _hoisted_109 = { class: "modal-body" }
const _hoisted_110 = {
  class: "modal fade",
  id: "modal_claim",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_111 = { class: "modal-dialog modal-dialog-centered modal-xl" }
const _hoisted_112 = { class: "modal-content p-15 p-md-40" }
const _hoisted_113 = { class: "modal-body" }
const _hoisted_114 = { class: "col-md-12 form-group mb-3" }
const _hoisted_115 = { class: "col-md-12 form-group mb-3" }
const _hoisted_116 = {
  key: 0,
  class: "col-md-12 form-group mb-3"
}
const _hoisted_117 = {
  key: 1,
  class: "col-md-12 form-group mb-3"
}
const _hoisted_118 = { class: "col-md-12 form-group mb-3" }
const _hoisted_119 = {
  key: 2,
  class: "col-md-12 form-group mb-3"
}
const _hoisted_120 = {
  key: 3,
  class: "col-md-12 form-group mb-3"
}
const _hoisted_121 = {
  key: 4,
  class: "col-md-12 form-group mb-3"
}
const _hoisted_122 = { class: "col-md-12 form-group mb-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_MyDateRangePicker = _resolveComponent("MyDateRangePicker")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_exported_today = _resolveComponent("exported-today")!
  const _component_HistoryColis = _resolveComponent("HistoryColis")!
  const _component_DetailsColis = _resolveComponent("DetailsColis")!
  const _component_UpdateParcel = _resolveComponent("UpdateParcel")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_router_link, {
            to: "/add-colis",
            class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0"
          }, {
            default: _withCtx(() => _cache[41] || (_cache[41] = [
              _createTextVNode(" Nouveau Colis ", -1),
              _createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1)
            ])),
            _: 1,
            __: [41]
          }),
          _createElementVNode("button", {
            class: "default-outline-btn position-relative transition fw-medium text-black pt-11 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 bg-success-subtle fs-md-15 fs-lg-16 d-inline-block mb-10 mb-lg-0",
            type: "button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.exportColis()))
          }, _cache[42] || (_cache[42] = [
            _createTextVNode(" Export ", -1),
            _createElementVNode("i", { class: "flaticon-file-1 position-relative ms-5 top-2 fs-15" }, null, -1)
          ]))
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("form", {
            class: "search-box position-relative",
            onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.filterList && _ctx.filterList(...args)), ["prevent"]))
          }, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchTerm) = $event)),
              type: "text",
              onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.filterList && _ctx.filterList(...args))),
              class: "form-control shadow-none text-black rounded-pill border ps-40",
              placeholder: "Chercher par code ou nom...",
              style: {"min-width":"300px","height":"45px","background":"#f8f9fa"}
            }, null, 544), [
              [_vModelText, _ctx.searchTerm]
            ]),
            _cache[43] || (_cache[43] = _createElementVNode("i", { class: "flaticon-search-interface-symbol position-absolute start-0 top-50 translate-middle-y ms-15 text-muted" }, null, -1))
          ], 32)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _cache[45] || (_cache[45] = _createElementVNode("label", { class: "form-label fw-semibold" }, "Date", -1)),
          _createElementVNode("div", {
            class: "d-flex border rounded bg-white",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showCalendarBox = !_ctx.showCalendarBox)),
            style: {"cursor":"pointer","height":"42px"}
          }, [
            _cache[44] || (_cache[44] = _createElementVNode("div", {
              class: "bg-light d-flex align-items-center justify-content-center border-end",
              style: {"width":"45px"}
            }, [
              _createElementVNode("i", { class: "flaticon-calendar text-muted" })
            ], -1)),
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.confirmedDate[0].format("MM/DD/YYYY")) + " - " + _toDisplayString(_ctx.confirmedDate[1].format("MM/DD/YYYY")), 1)
          ]),
          (_ctx.showCalendarBox)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                onClick: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop"])),
                class: "position-absolute start-0 mt-1 bg-white border shadow-lg rounded overflow-hidden",
                style: {"z-index":"1050","display":"flex","flex-direction":"column"}
              }, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.presets, (p) => {
                        return (_openBlock(), _createElementBlock("button", {
                          key: p.label,
                          onClick: ($event: any) => (_ctx.handlePresetClick(p)),
                          class: _normalizeClass(["list-group-item list-group-item-action border-0 py-2 px-3 text-start", 
                    _ctx.activePreset === p.label
                      ? 'active-blue'
                      : 'text-primary-link'
                  ])
                        }, _toDisplayString(p.label), 11, _hoisted_11))
                      }), 128))
                    ])
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_MyDateRangePicker, {
                      modelValue: _ctx.tempSelectedDate,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.tempSelectedDate) = $event)),
                      enableSecondCalendar: true
                    }, null, 8, ["modelValue"])
                  ], 512), [
                    [_vShow, _ctx.activePreset === 'Custom Range']
                  ])
                ]),
                (_ctx.activePreset === 'Custom Range')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.tempSelectedDate[0]?.format("MM/DD/YYYY")) + " - " + _toDisplayString(_ctx.tempSelectedDate[1]?.format("MM/DD/YYYY")), 1),
                      _createElementVNode("div", null, [
                        _createElementVNode("button", {
                          class: "btn btn-sm fw-bold me-3 text-dark",
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showCalendarBox = false))
                        }, " Cancel "),
                        _createElementVNode("button", {
                          class: "btn btn-sm px-4 fw-bold text-white",
                          style: {"background-color":"#2c3e8c"},
                          onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.applyCustomRange && _ctx.applyCustomRange(...args)))
                        }, " Apply ")
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_15, [
          _cache[46] || (_cache[46] = _createElementVNode("label", { class: "form-label fw-semibold" }, "Ville", -1)),
          _createVNode(_component_v_select, {
            modelValue: _ctx.city_filter,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.city_filter) = $event)),
            label: "name",
            options: _ctx.citiesList,
            class: "filter-select"
          }, null, 8, ["modelValue", "options"])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _cache[47] || (_cache[47] = _createElementVNode("label", { class: "form-label fw-semibold" }, "État", -1)),
          _createVNode(_component_v_select, {
            modelValue: _ctx.etat_filter,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.etat_filter) = $event)),
            label: "name",
            options: _ctx.etatList,
            class: "filter-select"
          }, null, 8, ["modelValue", "options"])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _cache[48] || (_cache[48] = _createElementVNode("label", { class: "form-label fw-semibold" }, "Status", -1)),
          _createVNode(_component_v_select, {
            modelValue: _ctx.status_filter,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.status_filter) = $event)),
            label: "name",
            options: _ctx.status,
            class: "filter-select"
          }, null, 8, ["modelValue", "options"])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("button", {
            class: "btn btn-primary px-4 me-2",
            onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.filterList && _ctx.filterList(...args)))
          }, _cache[49] || (_cache[49] = [
            _createElementVNode("i", { class: "flaticon-filter me-1" }, null, -1),
            _createTextVNode(" Filtrer ", -1)
          ])),
          _createElementVNode("button", {
            class: "btn btn-outline-secondary px-4",
            onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.removeFilter && _ctx.removeFilter(...args)))
          }, _cache[50] || (_cache[50] = [
            _createElementVNode("i", { class: "flaticon-refresh me-1" }, null, -1),
            _createTextVNode(" Annuler ", -1)
          ]))
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _cache[52] || (_cache[52] = _createElementVNode("label", { class: "me-2 text-paragraph fw-medium" }, "Afficher :", -1)),
          _withDirectives(_createElementVNode("select", {
            class: "form-select form-select-sm w-auto",
            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.filter.per_page) = $event)),
            onChange: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.changePerPage && _ctx.changePerPage(...args)))
          }, _cache[51] || (_cache[51] = [
            _createElementVNode("option", { value: 10 }, "10", -1),
            _createElementVNode("option", { value: 50 }, "50", -1),
            _createElementVNode("option", { value: 100 }, "100", -1),
            _createElementVNode("option", { value: 500 }, "500", -1)
          ]), 544), [
            [_vModelSelect, _ctx.filter.per_page]
          ]),
          _cache[53] || (_cache[53] = _createElementVNode("span", { class: "ms-2 text-paragraph" }, "lignes", -1))
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("table", _hoisted_23, [
              _cache[72] || (_cache[72] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
                  }, " Code d'envoi "),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                  }, " Dernière mise à jour "),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                  }, " Destinataire "),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                  }, " Etat "),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                  }, " Status "),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                  }, " Ville "),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                  }, " Prix "),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                  }, " ACTIONS "),
                  _createElementVNode("th", {
                    scope: "col",
                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                  }, " BONS ")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (row, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("th", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        (row.replace === 1)
                          ? (_openBlock(), _createElementBlock("h6", _hoisted_26, [
                              _createTextVNode(_toDisplayString(row.code) + " ", 1),
                              _cache[54] || (_cache[54] = _createElementVNode("i", { class: "ph ph-repeat" }, null, -1))
                            ]))
                          : (row.partial === 1)
                            ? (_openBlock(), _createElementBlock("h6", _hoisted_27, [
                                _createTextVNode(_toDisplayString(row.code) + " ", 1),
                                _cache[55] || (_cache[55] = _createElementVNode("i", { class: "ph ph-arrows-down-up" }, null, -1))
                              ]))
                            : (_openBlock(), _createElementBlock("h6", _hoisted_28, _toDisplayString(row.code), 1))
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_29, _toDisplayString(_ctx.getDate(row.updated_at)), 1),
                    _createElementVNode("td", _hoisted_30, [
                      _createElementVNode("p", _hoisted_31, [
                        _createElementVNode("b", null, _toDisplayString(row.receiver), 1),
                        _cache[56] || (_cache[56] = _createTextVNode()),
                        _cache[57] || (_cache[57] = _createElementVNode("br", null, null, -1)),
                        _createElementVNode("b", null, _toDisplayString(_ctx.oldPhone(row.phone)), 1),
                        _cache[58] || (_cache[58] = _createTextVNode()),
                        _cache[59] || (_cache[59] = _createElementVNode("br", null, null, -1))
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_32, [
                      _createElementVNode("span", {
                        class: _normalizeClass(`badge text-outline-${_ctx.resolveUserStatusVariant(
                    row.situation
                  )}`)
                      }, _toDisplayString(_ctx.resolveStatuParcel(row.situation)), 3)
                    ]),
                    _createElementVNode("td", _hoisted_33, [
                      _createElementVNode("div", {
                        class: "rounded-pill fs-13 badge text-bg-black custom-badge",
                        style: _normalizeStyle({ '--dynamic-bg': _ctx.getBadgeConfig(row).color })
                      }, [
                        _createTextVNode(_toDisplayString(_ctx.getBadgeConfig(row).text) + " ", 1),
                        (_ctx.getBadgeConfig(row).date)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _cache[60] || (_cache[60] = _createElementVNode("br", null, null, -1)),
                              _createTextVNode(_toDisplayString(_ctx.getBadgeConfig(row).date), 1)
                            ], 64))
                          : _createCommentVNode("", true),
                        (_ctx.getBadgeConfig(row).comment)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _cache[61] || (_cache[61] = _createElementVNode("br", null, null, -1)),
                              _createTextVNode(_toDisplayString(_ctx.getBadgeConfig(row).comment), 1)
                            ], 64))
                          : _createCommentVNode("", true)
                      ], 4)
                    ]),
                    _createElementVNode("td", _hoisted_34, [
                      _createElementVNode("b", null, _toDisplayString(row.city_name), 1)
                    ]),
                    _createElementVNode("td", _hoisted_35, [
                      _createElementVNode("b", null, _toDisplayString(row.price), 1),
                      _cache[62] || (_cache[62] = _createTextVNode("Dhs", -1)),
                      _cache[63] || (_cache[63] = _createElementVNode("br", null, null, -1)),
                      _createElementVNode("p", _hoisted_36, _toDisplayString(row.product_nature), 1)
                    ]),
                    _createElementVNode("td", _hoisted_37, [
                      _createElementVNode("div", _hoisted_38, [
                        _cache[71] || (_cache[71] = _createElementVNode("button", {
                          class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                          type: "button",
                          "data-bs-toggle": "dropdown",
                          "aria-expanded": "false"
                        }, [
                          _createElementVNode("i", { class: "flaticon-dots" })
                        ], -1)),
                        _createElementVNode("ul", _hoisted_39, [
                          _createElementVNode("li", null, [
                            _createElementVNode("button", {
                              class: "dropdown-item d-flex align-items-center",
                              onClick: ($event: any) => (_ctx.showDetailSuivi(row))
                            }, _cache[64] || (_cache[64] = [
                              _createElementVNode("i", { class: "flaticon-clock lh-1 me-8 position-relative top-1" }, null, -1),
                              _createTextVNode(" Historique ", -1)
                            ]), 8, _hoisted_40)
                          ]),
                          _createElementVNode("li", null, [
                            _createElementVNode("button", {
                              class: "dropdown-item d-flex align-items-center",
                              onClick: ($event: any) => (_ctx.showDetails(row))
                            }, _cache[65] || (_cache[65] = [
                              _createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }, null, -1),
                              _createTextVNode(" Détails ", -1)
                            ]), 8, _hoisted_41)
                          ]),
                          _createElementVNode("li", null, [
                            _createElementVNode("a", {
                              class: "dropdown-item d-flex align-items-center",
                              href: "javascript:void(0);",
                              onClick: ($event: any) => (_ctx.claimParcel(row))
                            }, _cache[66] || (_cache[66] = [
                              _createElementVNode("i", { class: "flaticon-communication lh-1 me-8 position-relative top-1" }, null, -1),
                              _createTextVNode(" Réclamer ", -1)
                            ]), 8, _hoisted_42)
                          ]),
                          _createElementVNode("li", null, [
                            _createElementVNode("a", {
                              class: "dropdown-item d-flex align-items-center",
                              target: "_blank",
                              href: `https://api.whatsapp.com/send?phone=${_ctx.SubstrPhone(
                          row.phone
                        )}&text=Client : ${row.phone} Téléphone : ${
                          row.customer_phone
                        } Code d'envoi : ${row.code} Destinataire : ${
                          row.receiver
                        } Téléphone : ${row.phone} Ville : ${
                          row.city_name
                        } Adresse : ${row.address} Commentaire : ${
                          row.note
                        } Produit : ${row.product_nature} Crbt : ${
                          row.price
                        } DH`
                            }, _cache[67] || (_cache[67] = [
                              _createElementVNode("i", { class: "ph ph-whatsapp-logo lh-1 me-8 position-relative top-1" }, null, -1),
                              _createTextVNode(" WhatsApp ", -1)
                            ]), 8, _hoisted_43)
                          ]),
                          _createElementVNode("li", null, [
                            _createElementVNode("button", {
                              class: "dropdown-item d-flex align-items-center",
                              onClick: ($event: any) => (_ctx.callPhone(row.phone))
                            }, _cache[68] || (_cache[68] = [
                              _createElementVNode("i", { class: "ph ph-phone lh-1 me-8 position-relative top-1" }, null, -1),
                              _createTextVNode(" Appeler destinaire ", -1)
                            ]), 8, _hoisted_44)
                          ]),
                          (row.status === 'NEW_PARCEL')
                            ? (_openBlock(), _createElementBlock("li", _hoisted_45, [
                                _createElementVNode("a", {
                                  class: "dropdown-item d-flex align-items-center",
                                  href: "javascript:void(0);",
                                  onClick: ($event: any) => (_ctx.Destroy_Coli(row))
                                }, _cache[69] || (_cache[69] = [
                                  _createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }, null, -1),
                                  _createTextVNode(" Supprimer ", -1)
                                ]), 8, _hoisted_46)
                              ]))
                            : _createCommentVNode("", true),
                          (row.status == 'NEW_PARCEL')
                            ? (_openBlock(), _createElementBlock("li", _hoisted_47, [
                                _createElementVNode("a", {
                                  class: "dropdown-item d-flex align-items-center",
                                  href: "javascript:void(0);",
                                  onClick: ($event: any) => (_ctx.showUpdate(row))
                                }, _cache[70] || (_cache[70] = [
                                  _createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1),
                                  _createTextVNode(" Modifier ", -1)
                                ]), 8, _hoisted_48)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_49, [
                      _withDirectives(_createElementVNode("span", null, [
                        _createElementVNode("ul", _hoisted_50, [
                          (row.delivery_note != 0)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_51, [
                                _createElementVNode("a", {
                                  style: {"cursor":"pointer"},
                                  target: "_blank",
                                  onClick: ($event: any) => (_ctx.voirItem(row.delivery_note, '1'))
                                }, _toDisplayString(row.delivery_note_ref), 9, _hoisted_52)
                              ]))
                            : _createCommentVNode("", true),
                          (row.delivery_note != 0)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_53, [
                                _createElementVNode("a", {
                                  style: {"cursor":"pointer"},
                                  target: "_blank",
                                  onClick: ($event: any) => (_ctx.voirItem(row.delivery_note, '0'))
                                }, _toDisplayString(row.delivery_note_ref), 9, _hoisted_54)
                              ]))
                            : _createCommentVNode("", true),
                          (row.rn_c_ref != 0)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_55, [
                                _createElementVNode("a", {
                                  onClick: ($event: any) => (_ctx.voirItem(row.rn_c, '2')),
                                  style: {"cursor":"pointer"}
                                }, _toDisplayString(row.rn_c_ref), 9, _hoisted_56)
                              ]))
                            : _createCommentVNode("", true),
                          (
                        row.bons && row.bons.inv && row.bons.inv.length != 0
                      )
                            ? (_openBlock(), _createElementBlock("li", _hoisted_57, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.bons.inv, (invoice, index) => {
                                  return (_openBlock(), _createElementBlock("a", {
                                    key: index,
                                    onClick: ($event: any) => (_ctx.voirItem(invoice.invoice_id, '3')),
                                    style: {"cursor":"pointer"}
                                  }, _toDisplayString(invoice.invoice_code), 9, _hoisted_58))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ], 512), [
                        [_vShow, _ctx.showRefs]
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_59, [
          _createElementVNode("div", _hoisted_60, [
            _cache[74] || (_cache[74] = _createElementVNode("label", { class: "me-2 text-paragraph fw-medium" }, "Afficher :", -1)),
            _withDirectives(_createElementVNode("select", {
              class: "form-select form-select-sm w-auto",
              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.filter.per_page) = $event)),
              onChange: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.changePerPage && _ctx.changePerPage(...args)))
            }, _cache[73] || (_cache[73] = [
              _createElementVNode("option", { value: 10 }, "10", -1),
              _createElementVNode("option", { value: 50 }, "50", -1),
              _createElementVNode("option", { value: 100 }, "100", -1),
              _createElementVNode("option", { value: 500 }, "500", -1)
            ]), 544), [
              [_vModelSelect, _ctx.filter.per_page]
            ]),
            _cache[75] || (_cache[75] = _createElementVNode("span", { class: "ms-2 text-paragraph" }, "lignes", -1))
          ]),
          _createElementVNode("p", _hoisted_61, [
            _cache[76] || (_cache[76] = _createTextVNode(" Showing ", -1)),
            _createElementVNode("span", _hoisted_62, _toDisplayString((_ctx.filter.current_page - 1) * _ctx.filter.per_page + 1), 1),
            _cache[77] || (_cache[77] = _createTextVNode(" – ", -1)),
            _createElementVNode("span", _hoisted_63, _toDisplayString(Math.min(_ctx.filter.current_page * _ctx.filter.per_page, _ctx.filter.total)), 1),
            _cache[78] || (_cache[78] = _createTextVNode(" out of ", -1)),
            _createElementVNode("span", _hoisted_64, _toDisplayString(_ctx.filter.total), 1),
            _cache[79] || (_cache[79] = _createTextVNode(" results ", -1))
          ]),
          _createElementVNode("nav", _hoisted_65, [
            _createElementVNode("ul", _hoisted_66, [
              (_ctx.displayedPages[0] > 1)
                ? (_openBlock(), _createElementBlock("li", _hoisted_67, [
                    _createElementVNode("a", {
                      class: "page-link",
                      href: "javascript:void(0)",
                      onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.goToPage(1)))
                    }, "1")
                  ]))
                : _createCommentVNode("", true),
              (_ctx.displayedPages[0] > 2)
                ? (_openBlock(), _createElementBlock("li", _hoisted_68, _cache[80] || (_cache[80] = [
                    _createElementVNode("span", { class: "page-link" }, "...", -1)
                  ])))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayedPages, (page) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: page,
                  class: "page-item"
                }, [
                  _createElementVNode("a", {
                    href: "javascript:void(0)",
                    class: _normalizeClass(["page-link", { active: _ctx.filter.current_page === page }]),
                    onClick: ($event: any) => (_ctx.goToPage(page))
                  }, _toDisplayString(page), 11, _hoisted_69)
                ]))
              }), 128)),
              (
                _ctx.displayedPages[_ctx.displayedPages.length - 1] < _ctx.filter.last_page - 1
              )
                ? (_openBlock(), _createElementBlock("li", _hoisted_70, _cache[81] || (_cache[81] = [
                    _createElementVNode("span", { class: "page-link" }, "...", -1)
                  ])))
                : _createCommentVNode("", true),
              (
                _ctx.displayedPages[_ctx.displayedPages.length - 1] < _ctx.filter.last_page
              )
                ? (_openBlock(), _createElementBlock("li", _hoisted_71, [
                    _createElementVNode("a", {
                      class: "page-link",
                      href: "javascript:void(0)",
                      onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.goToPage(_ctx.filter.last_page)))
                    }, _toDisplayString(_ctx.filter.last_page), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_72, [
      _createElementVNode("div", _hoisted_73, [
        _createElementVNode("div", _hoisted_74, [
          _cache[95] || (_cache[95] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h1", { class: "modal-title fs-5" }, "Filtrer"),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_75, [
            _createElementVNode("form", _hoisted_76, [
              _createElementVNode("div", _hoisted_77, [
                _createElementVNode("div", _hoisted_78, [
                  _cache[82] || (_cache[82] = _createElementVNode("label", null, "Zone:", -1)),
                  _createVNode(_component_v_select, {
                    class: "custom-select-height",
                    modelValue: _ctx.zone_filter,
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.zone_filter) = $event)),
                    label: "name",
                    options: _ctx.zonesList
                  }, null, 8, ["modelValue", "options"])
                ])
              ]),
              _createElementVNode("div", _hoisted_79, [
                _createElementVNode("div", _hoisted_80, [
                  _cache[83] || (_cache[83] = _createElementVNode("label", null, "Ville:", -1)),
                  _createVNode(_component_v_select, {
                    class: "custom-select-height",
                    modelValue: _ctx.city_filter,
                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.city_filter) = $event)),
                    label: "name",
                    options: _ctx.citiesList
                  }, null, 8, ["modelValue", "options"])
                ])
              ]),
              _createElementVNode("div", _hoisted_81, [
                _createElementVNode("div", _hoisted_82, [
                  _cache[84] || (_cache[84] = _createElementVNode("label", null, "Etat:", -1)),
                  _createVNode(_component_v_select, {
                    class: "custom-select-height",
                    modelValue: _ctx.etat_filter,
                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.etat_filter) = $event)),
                    style: {"border-color":"#0000002b"},
                    label: "name",
                    options: _ctx.etatList
                  }, null, 8, ["modelValue", "options"])
                ])
              ]),
              _createElementVNode("div", _hoisted_83, [
                _createElementVNode("div", _hoisted_84, [
                  _cache[85] || (_cache[85] = _createElementVNode("label", null, "Status:", -1)),
                  _createVNode(_component_v_select, {
                    class: "custom-select-height",
                    modelValue: _ctx.status_filter,
                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.status_filter) = $event)),
                    style: {"border-color":"#0000002b"},
                    label: "name",
                    options: _ctx.status
                  }, null, 8, ["modelValue", "options"])
                ])
              ]),
              _createElementVNode("div", _hoisted_85, [
                _createElementVNode("div", _hoisted_86, [
                  _cache[87] || (_cache[87] = _createElementVNode("label", null, "Par Date de:", -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.type_date_filter) = $event)),
                    class: "form-control"
                  }, _cache[86] || (_cache[86] = [
                    _createStaticVNode("<option value=\"ADD_DATE\" data-v-49698963>Date de création</option><option value=\"LAST_UPDATE\" data-v-49698963>Dernière Mise à jour</option><option value=\"PICKED_DATE\" data-v-49698963>Date de ramassage</option><option value=\"SENT_DATE\" data-v-49698963>Date d&#39;expédition</option><option value=\"DELIVERY_DATE\" data-v-49698963>Date de livraison</option><option value=\"POSTPONED_DATE\" data-v-49698963>Date reportée</option>", 6)
                  ]), 512), [
                    [_vModelSelect, _ctx.type_date_filter]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_87, [
                _createElementVNode("div", _hoisted_88, [
                  _cache[89] || (_cache[89] = _createElementVNode("label", null, "Ajouté Au BPL:", -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.add_bp_filter) = $event)),
                    class: "form-control"
                  }, _cache[88] || (_cache[88] = [
                    _createElementVNode("option", { value: "" }, "Tous", -1),
                    _createElementVNode("option", { value: "0" }, "Non Ajouté Au BPL", -1),
                    _createElementVNode("option", { value: "1" }, "Ajouté Au BPL et Non Payé", -1)
                  ]), 512), [
                    [_vModelSelect, _ctx.add_bp_filter]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_89, [
                _createElementVNode("div", _hoisted_90, [
                  _cache[91] || (_cache[91] = _createElementVNode("label", null, "Afficher Réf:", -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.ref_filter) = $event)),
                    class: "form-control",
                    onChange: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_ctx.showRefsEdit && _ctx.showRefsEdit(...args)))
                  }, _cache[90] || (_cache[90] = [
                    _createElementVNode("option", { value: "" }, "Tous", -1),
                    _createElementVNode("option", { value: "1" }, "Afficher les Ref", -1),
                    _createElementVNode("option", { value: "0" }, "Ne pas afficher les Refs", -1)
                  ]), 544), [
                    [_vModelSelect, _ctx.ref_filter]
                  ])
                ])
              ]),
              _createElementVNode("template", null, [
                _createElementVNode("div", _hoisted_91, [
                  _createElementVNode("div", _hoisted_92, [
                    _cache[93] || (_cache[93] = _createElementVNode("label", null, "Prix 0DH:", -1)),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.price_filter) = $event)),
                      class: "form-control"
                    }, _cache[92] || (_cache[92] = [
                      _createElementVNode("option", { value: "" }, "Tous", -1),
                      _createElementVNode("option", { value: "1" }, "Oui", -1),
                      _createElementVNode("option", { value: "0" }, "Non", -1)
                    ]), 512), [
                      [_vModelSelect, _ctx.price_filter]
                    ])
                  ])
                ])
              ]),
              _cache[94] || (_cache[94] = _createElementVNode("div", { class: "col-md-4" }, [
                _createElementVNode("div", { class: "form-group mb-3" }, [
                  _createElementVNode("label", null, "Par Date:")
                ])
              ], -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_93, [
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[29] || (_cache[29] = 
//@ts-ignore
(...args) => (_ctx.filterList && _ctx.filterList(...args))),
              class: "btn btn-primary"
            }, " Annuler "),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[30] || (_cache[30] = 
//@ts-ignore
(...args) => (_ctx.removeFilter && _ctx.removeFilter(...args))),
              class: "btn btn-warning"
            }, " Appliquer ")
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_94, [
      _createElementVNode("div", _hoisted_95, [
        _createElementVNode("div", _hoisted_96, [
          _cache[96] || (_cache[96] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h1", { class: "modal-title fs-5" }, "Colis reportés pour aujourd'hui"),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_97, [
            _createVNode(_component_exported_today)
          ]),
          _cache[97] || (_cache[97] = _createElementVNode("div", { class: "modal-footer" }, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary",
              "data-bs-dismiss": "modal"
            }, " Fermer ")
          ], -1))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_98, [
      _createElementVNode("div", _hoisted_99, [
        _createElementVNode("div", _hoisted_100, [
          _cache[98] || (_cache[98] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h5", { class: "modal-title" }, "Historique Colis"),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Fermer"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_101, [
            (_ctx.colisId)
              ? (_openBlock(), _createBlock(_component_HistoryColis, {
                  key: 0,
                  colisId: _ctx.colisId,
                  isOpen: _ctx.isOpen
                }, null, 8, ["colisId", "isOpen"]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_102, [
      _createElementVNode("div", _hoisted_103, [
        _createElementVNode("div", _hoisted_104, [
          _cache[99] || (_cache[99] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h5", { class: "modal-title" }, "Détails Colis"),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Fermer"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_105, [
            (_ctx.coliDetails)
              ? (_openBlock(), _createBlock(_component_DetailsColis, {
                  key: 0,
                  coliDetails: _ctx.coliDetails,
                  isOpen: _ctx.isOpen
                }, null, 8, ["coliDetails", "isOpen"]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_106, [
      _createElementVNode("div", _hoisted_107, [
        _createElementVNode("div", _hoisted_108, [
          _cache[100] || (_cache[100] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h5", { class: "modal-title" }, "Modifier Colis"),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Fermer"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_109, [
            (_ctx.rowUpdate)
              ? (_openBlock(), _createBlock(_component_UpdateParcel, {
                  key: 0,
                  rowColis: _ctx.rowUpdate,
                  getRecords: _ctx.getRecords
                }, null, 8, ["rowColis", "getRecords"]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _cache[112] || (_cache[112] = _createStaticVNode("<div class=\"modal fade\" id=\"modal_fees_edit\" tabindex=\"-1\" aria-hidden=\"true\" data-v-49698963><div class=\"modal-dialog modal-dialog-centered modal-xl\" data-v-49698963><div class=\"modal-content p-15 p-md-40\" data-v-49698963><div class=\"modal-header\" data-v-49698963><h5 class=\"modal-title\" data-v-49698963>Modifier les frais</h5><button type=\"button\" class=\"btn-close\" data-bs-dismiss=\"modal\" aria-label=\"Fermer\" data-v-49698963></button></div><div class=\"modal-body\" data-v-49698963></div></div></div></div>", 1)),
    _createElementVNode("div", _hoisted_110, [
      _createElementVNode("div", _hoisted_111, [
        _createElementVNode("div", _hoisted_112, [
          _cache[111] || (_cache[111] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h5", { class: "modal-title" }, "Réclamation"),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Fermer"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_113, [
            _createElementVNode("form", {
              onSubmit: _cache[40] || (_cache[40] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.addClaim && _ctx.addClaim(...args)), ["prevent"])),
              class: "row"
            }, [
              _createElementVNode("div", _hoisted_114, [
                _cache[101] || (_cache[101] = _createElementVNode("label", {
                  for: "claim-code",
                  class: "form-label"
                }, "Code Colis *", -1)),
                _withDirectives(_createElementVNode("input", {
                  id: "claim-code",
                  "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.claimForm.code_colis) = $event)),
                  type: "text",
                  class: "form-control",
                  disabled: ""
                }, null, 512), [
                  [_vModelText, _ctx.claimForm.code_colis]
                ])
              ]),
              _createElementVNode("div", _hoisted_115, [
                _cache[102] || (_cache[102] = _createElementVNode("label", {
                  for: "claim-object",
                  class: "form-label"
                }, "Type de réclamation *", -1)),
                _createVNode(_component_v_select, {
                  label: "name",
                  options: _ctx.claimObjects,
                  modelValue: _ctx.claimForm.object,
                  "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.claimForm.object) = $event)),
                  class: "custom-select-height"
                }, null, 8, ["options", "modelValue"])
              ]),
              (_ctx.claimForm.object?.name == 'Changement de prix')
                ? (_openBlock(), _createElementBlock("div", _hoisted_116, [
                    _cache[103] || (_cache[103] = _createElementVNode("label", {
                      for: "claim-price",
                      class: "form-label"
                    }, "Nouveau prix *", -1)),
                    _withDirectives(_createElementVNode("input", {
                      id: "claim-price",
                      "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.claimForm.price) = $event)),
                      type: "number",
                      min: "0",
                      placeholder: "Nouveau prix *",
                      class: "form-control"
                    }, null, 512), [
                      [_vModelText, _ctx.claimForm.price]
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.claimForm.object?.name == 'Rembourssement')
                ? (_openBlock(), _createElementBlock("div", _hoisted_117, [
                    _cache[104] || (_cache[104] = _createElementVNode("label", {
                      for: "claim-price-remb",
                      class: "form-label"
                    }, "Prix à rembourser *", -1)),
                    _withDirectives(_createElementVNode("input", {
                      id: "claim-price-remb",
                      "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.claimForm.priceRemb) = $event)),
                      type: "number",
                      min: "0",
                      placeholder: "Prix à rembourser *",
                      class: "form-control"
                    }, null, 512), [
                      [_vModelText, _ctx.claimForm.priceRemb]
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_118, [
                _cache[105] || (_cache[105] = _createElementVNode("label", {
                  for: "claim-city",
                  class: "form-label"
                }, "Ville *", -1)),
                _createVNode(_component_v_select, {
                  id: "claim-city",
                  label: "name",
                  modelValue: _ctx.claimForm.city,
                  "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.claimForm.city) = $event)),
                  options: _ctx.claimCitiesList,
                  class: "custom-select-height"
                }, null, 8, ["modelValue", "options"])
              ]),
              (_ctx.claimForm.object?.name == 'Changement Adresse/Client')
                ? (_openBlock(), _createElementBlock("div", _hoisted_119, [
                    _cache[106] || (_cache[106] = _createElementVNode("label", {
                      for: "claim-adresse",
                      class: "form-label"
                    }, "Nouveau Adresse", -1)),
                    _withDirectives(_createElementVNode("textarea", {
                      id: "claim-adresse",
                      rows: "2",
                      "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.claimForm.adresse) = $event)),
                      placeholder: "Nouveau Adresse",
                      class: "form-control"
                    }, null, 512), [
                      [_vModelText, _ctx.claimForm.adresse]
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.claimForm.object?.name == 'Changement Adresse/Client')
                ? (_openBlock(), _createElementBlock("div", _hoisted_120, [
                    _cache[107] || (_cache[107] = _createElementVNode("label", {
                      for: "claim-reciever",
                      class: "form-label"
                    }, "Nouveau Destinataire", -1)),
                    _withDirectives(_createElementVNode("input", {
                      id: "claim-reciever",
                      "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.claimForm.reciever) = $event)),
                      placeholder: "Nouveau Destinataire",
                      class: "form-control"
                    }, null, 512), [
                      [_vModelText, _ctx.claimForm.reciever]
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.claimForm.object?.name == 'Changement Adresse/Client')
                ? (_openBlock(), _createElementBlock("div", _hoisted_121, [
                    _cache[108] || (_cache[108] = _createElementVNode("label", {
                      for: "claim-phone",
                      class: "form-label"
                    }, "Nouveau Numéro Téléphone", -1)),
                    _withDirectives(_createElementVNode("input", {
                      id: "claim-phone",
                      type: "text",
                      pattern: "[0-9]*",
                      "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.claimForm.phone) = $event)),
                      placeholder: "Nouveau Numéro Téléphone",
                      maxlength: "10",
                      class: "form-control"
                    }, null, 512), [
                      [_vModelText, _ctx.claimForm.phone]
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_122, [
                _cache[109] || (_cache[109] = _createElementVNode("label", {
                  for: "claim-msg",
                  class: "form-label"
                }, "Message *", -1)),
                _withDirectives(_createElementVNode("textarea", {
                  id: "claim-msg",
                  rows: "2",
                  "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.claimForm.msg) = $event)),
                  placeholder: "Message *",
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.claimForm.msg]
                ])
              ]),
              _cache[110] || (_cache[110] = _createElementVNode("div", { class: "col-md-12" }, [
                _createElementVNode("button", {
                  type: "submit",
                  class: "btn btn-primary"
                }, [
                  _createElementVNode("span", { class: "text-nowrap" }, "Enregistrer")
                ])
              ], -1))
            ], 32)
          ])
        ])
      ])
    ])
  ], 64))
}